
//:key="$route.fullPath"
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class surveys extends Vue {
  name: String = "surveys";
}
